import { graphRequest, msalInstance } from './msal'

/**
 * Henter brugerens profilbillede fra Microsoft 365 (Graph).
 *
 * Kaldet sker fra frontenden med et Graph-token som MSAL henter lydløst.
 * Dermed slipper API-et for at kende en client secret og for at kalde Graph
 * på brugerens vegne (se docs/DECISIONS.md beslutning 016).
 *
 * Returnerer null hvis brugeren ikke har et billede i 365, ikke er logget ind
 * med Microsoft, eller hvis tokenet ikke kan fornyes uden brugerinteraktion.
 */
export async function fetchMicrosoftProfilePhoto(): Promise<Blob | null> {
  if (!msalInstance) {
    return null
  }

  const account = msalInstance.getActiveAccount() ?? msalInstance.getAllAccounts()[0]
  if (!account) {
    return null
  }

  try {
    const result = await msalInstance.acquireTokenSilent({ ...graphRequest, account })

    const response = await fetch('https://graph.microsoft.com/v1.0/me/photo/$value', {
      headers: { Authorization: `Bearer ${result.accessToken}` }
    })

    // 404 betyder blot at brugeren ikke har uploadet et billede i Microsoft 365.
    if (!response.ok) {
      return null
    }

    return await response.blob()
  } catch {
    return null
  }
}
